$(document).ready(function() {

   $(document).on('click', '.js-subscribe-modal', function() {
       let modal = $('#new-subscriber-modal');
       let form = modal.find('.js-modal-subscriber-create');
       resetValidation(form)
       $(modal).modal('show');
   });

    $(document).on('click', '.js-close-subscribe-modal-btn', function() {
        const modal = $('#new-subscriber-modal');
        $(modal).modal('hide');
    });

    $('.js-create-subscriber-btn').on('click', function () {
        let $el = $(this);
        let modal = $('#new-subscriber-modal');
        let form = modal.find('.js-modal-subscriber-create')
        resetValidation(form);
        // $(modal).modal('hide');
        // $el.prop('disabled', true)
        $.ajax({
            url: form.attr('action'),
            data: form.serialize(),
            method: "POST",
            success: function (response) {
                modal.find('.js-close-subscribe-modal-btn').click()
                $el.prop('disabled', false)
                window.notify(response.text, response.type)
                form.trigger("reset");
                resetValidation(form);
                $(modal).modal('hide');
            },
            error: function (xhr) {
                let response = JSON.parse(xhr.responseText);
                window.notify(response.message, 'info');
                resetValidation(form);
                displayErrors(form, response.errors);
                $el.prop('disabled', false)
            }
        })
    })


    function resetValidation(form)
    {
        form.find('.is-invalid').removeClass('is-invalid')
        form.find('.error-text').html('')
    }

});
